<template>
  <LoginWrapper>
    <Loading :show="true" v-if="loading" style="color:#ddd;" />
    <div class="find-password-content" v-else>
      <div v-if="success">
        <!-- 成功提示 -->
        <div class="find-password-form">
          <div class="find-password-sended">
            <div class="find-password-tip">
              <Icon type="reset-success" />
              <p>{{ $t('find_password_success_tip3') }}</p>
            </div>
          </div>
          <div class="find-password-btn">
            <a-button type="primary" @click="backLogin">
              {{ $t('find_password_back') }}
            </a-button>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="find-password-title">
          {{ $t('find_password_reset_title') }}

          <a-button
            type="link"
            size="small"
            style="position:absolute;right:-40px;top:10px;"
            icon="double-left"
            @click="backLogin"
          >
            {{ $t('com_btn_back') }}
          </a-button>
        </div>
        <div class="find-password-form find-password-link-error" v-if="linkDead">
          <p>{{ $t('find_password_expired') }}</p>
          <router-link to="/find-password">
            <a-button type="primary">{{ $t('find_password_resend') }}</a-button>
          </router-link>
        </div>

        <div class="find-password-form" v-else>
          <a-form-model :model="form" :rules="rules" ref="formElement">
            <a-form-model-item prop="password" :help="$t('com_form_password_help')">
              <a-input-password
                v-model="form.password"
                size="large"
                style="min-width:200px"
                :placeholder="$t('find_password_new_password_placeholder')"
                allowClear
              >
                <Icon type="lock" slot="prefix" />
              </a-input-password>
            </a-form-model-item>

            <a-form-model-item prop="confirmPassword" :help="$t('com_form_password_help')">
              <a-input-password
                v-model="form.confirmPassword"
                size="large"
                style="min-width:200px"
                :placeholder="$t('find_password_confrim_password_placeholder')"
                allowClear
              >
                <Icon type="lock" slot="prefix" />
              </a-input-password>
            </a-form-model-item>

            <div class="find-password-btn">
              <a-button type="primary" @click="resetSubmit" :loading="submtting">
                {{ $t('com_btn_submit') }}
              </a-button>
            </div>
          </a-form-model>

          <!-- 错误描述 -->
          <div class="g-form-error" style="padding-top:25px;width:100%;justify-content: center;">
            <Icon type="error" v-if="formError" />
            <p>{{ formError }}</p>
          </div>
        </div>
      </div>
    </div>
  </LoginWrapper>
</template>
<script>
import * as API from '@/api/findPassword';
import { checkPassword } from '@/libs/validator';
import LoginWrapper from '@/components/Layout/Login.vue';

export default {
  components: {
    LoginWrapper,
  },
  data() {
    return {
      loading: true,
      key: '',
      formError: '',
      linkDead: false,

      form: {
        password: undefined,
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t('find_password_new_password_placeholder'),
            trigger: 'change',
          },
          { validator: this.validatePassword, trigger: 'change' },
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t('find_password_confrim_password_placeholder'),
            trigger: 'change',
          },
          { validator: this.comfrimPassword, trigger: 'change' },
        ],
      },
      submtting: false,
      // 设置成功
      success: false,
    };
  },

  created() {
    if (this.$route && this.$route.query && this.$route.query.k) {
      this.key = this.$route.query.k;

      this.validateKey();
    }
  },

  methods: {
    // 验证链接有效期
    validateKey() {
      API.ValidateLink({ key: this.key }).then(res => {
        this.loading = false;
        if (res.code !== 0) {
          // 提示错误，重新找回
          this.linkDead = true;
        }
      });
    },

    // 验证新密码
    validatePassword(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!checkPassword(value)) {
        callback(this.$t('find_password_strong'));
        return;
      }
      callback();
    },

    // 确认新密码
    comfrimPassword(rule, value, callback) {
      if (value && value !== this.form.password) {
        callback(this.$t('find_password_equal'));
      } else {
        callback();
      }
    },

    // 返回上一步
    backLogin() {
      window.location.href = '/login';
    },

    resetSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid && !this.linkDead) {
          const params = {
            key: this.key,
            password: this.form.password,
          };
          this.submtting = true;
          this.formError = '';
          API.ResetPassword(params)
            .then(res => {
              if (res.code === 0) {
                this.success = true;
                // const h = this.$createElement;
                // this.$success({
                //   title: 'Tips',
                //   centered: true,
                //   content: h('div', {}, [
                //     h('p', this.$t('find_password_success_tip3')),
                //   ]),
                //   onOk: () => {
                //     this.backLogin();
                //   },
                // });
              } else {
                this.formError = res.message;
              }
            })
            .finally(() => {
              this.submtting = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.find-password-content {
  background: #fff;
  width: 600px;
  border-radius: 10px;
  margin: 0 60px 80px 60px;

  // 标题
  .find-password-title {
    color: #18181a;
    font-size: 36px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    padding: 60px 0 50px 0;
    position: relative;

    span {
      font-size: 14px;
      color: #999;
      position: absolute;
      left: 10px;
    }
  }

  // 表单
  .find-password-form {
    padding: 25px;

    // 验证码
    .captcha {
      display: flex;
      .captcha-left {
        flex: 1;
      }

      .captcha-right {
        width: 120px;
        display: flex;
        justify-content: right;
        margin-top: 40px;
        .captcha-img {
          width: 110px;
          background: #eee;
          height: 40px;
          border-radius: 4px;
          overflow: hidden;

          img {
            width: auto;
            height: 100%;
            max-width: 100%;
            max-height: 40px;
            cursor: pointer;
          }
        }
      }
    }

    .find-password-tip {
      color: #2196f3;
      text-align: center;

      p {
        color: #18181a;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      svg {
        width: 120px;
        height: auto;
        font-size: 24px;
      }
    }

    ::v-deep .find-password-btn {
      padding-top: 20px;
      text-align: center;

      .ant-btn-primary {
        font-size: 18px;
        height: 50px;
        width: 100%;
        border-radius: 8px;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
      }
      button {
        width: 100%;
        cursor: pointer;
      }
    }
  }

  .find-password-link-error {
    text-align: center;
    height: 200px;
    p {
      color: #f00;
      font-size: 14px;
      padding: 20px 0 10px;
    }
  }
}
</style>
